import { useQuery } from "react-query";

import type { ExtraProfileField } from "@jti/fe-common";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { CasProfileApi } from "../../services";

type CustomAttrs = {
  data: ExtraProfileField;
  isLoading: boolean;
};

export const useCustomAttrs = (): CustomAttrs => {
  const casProfileApi = CasProfileApi.init();
  const query = useQuery(QUERY_KEYS.profile, () => casProfileApi.getProfile(), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    data: query?.data?.extra || {},
    isLoading: query.isLoading,
  };
};
